<template>
  <div>
    <HeaderBreadcrumbs
      :items="[
        { label: 'Admin', to: '/user-admin' },
        { label: 'Edit' }
      ]"
      title="Edit Admin"
    />

    <div class="flex-col w-full mb-3 bg-white rounded-lg">
      <div class="flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg">
        <div class="flex flex-col w-1/2">
          <FormLabel htmlFor="email">
            Email
          </FormLabel>

          <TextInput
            type="email"
            id="email"
            placeholder="Enter Email Address"
             :variant="((isSubmitted && !form.email.trim())) || emailAlreadyExists ? 'error' : 'default'"
            v-model="form.email"
          />

          <div v-if="isSubmitted && isEmailError" class="mt-1 text-sm text-red-500">Must be filled.</div>
            <div v-if="isSubmitted && form.email.trim() && emailAlreadyExists" class="mt-1 text-sm text-red-500">Email already exists.</div>

              <FormLabel htmlFor="group" className="mt-3">
            Group
          </FormLabel>
          <SelectRadio
            id="group"  
            defaultText="Select Group"
            v-model="form.group"
            :options="groupOptions"
            @input="changeGroup"
            :isError="isSubmitted && isGroupError"
          />

          <div v-if="isSubmitted && isGroupError" class="mt-1 text-sm text-red-500">Must be filled.</div>

             <div v-if="form.group === 'publisher'">
            <FormLabel htmlFor="vendor" className="mt-3">
              Publisher
            </FormLabel>

            <multiselect
              v-model="form.vendor"
              label="name"
              track-by="name"
              placeholder="Type to find publisher"
              open-direction="bottom"
              class="box-border custom-multiselect"
              :class="isSubmitted && isVendorError ? 'error' : ''"
              :options="vendorOptions"
              :searchable="true"
              :loading="isLoadingVendor"
              :close-on-select="true"
              @search-change="handleSearchVendor"
            >
              <span slot="noResult">
                Oops! No elements found. Consider changing the search query.
              </span>
            </multiselect>

            <div v-if="isSubmitted && isVendorError" class="mt-1 text-sm text-red-500">Must be filled.</div>
          </div>
    <div v-if="form.group === 'publisher_group'">
            <FormLabel htmlFor="vendor" className="mt-3">
              Publisher Group
            </FormLabel>

            <multiselect
              v-model="form.vendor_group"
              label="name"
              track-by="name"
              placeholder="Type to find publisher"
              open-direction="bottom"
              class="box-border custom-multiselect"
              :class="isSubmitted && isVendoGroupError ? 'error' : ''"
              :options="vendorGroupOption"
              :searchable="true"
              :loading="isLoadingVendorGroup"
              :close-on-select="true"
              @search-change="handleSearchVendorGroup"
            >
              <span slot="noResult">
                Oops! No elements found. Consider changing the search query.
              </span>
            </multiselect>
          </div>
            <div v-if="isSubmitted && isVendoGroupError" class="mt-1 text-sm text-red-500">Must be filled.</div>
    
          <FormLabel htmlFor="role" className="mt-3">
            Role
          </FormLabel>

          <SelectRadio
            id="role"
            defaultText="Select Role"
            v-model="form.role"
            :value="form.role"
            :options="roleOption"
            :isError="isSubmitted && isRoleError"
          />

          <div v-if="isSubmitted && isRoleError" class="mt-1 text-sm text-red-500">Must be filled.</div>

          <FormLabel htmlFor="status" className="mt-3">
            Status
          </FormLabel>

          <GmSwitch id="status" v-model="form.isActive"/>

          <div class="flex gap-5 mt-4">
            <Button @click="handleUpdateUserAdmin" :disabled="isLoadingUpdate">
              {{ isLoadingUpdate ? 'Updating...' : 'Save' }}
            </Button>

            <Button
              variant="outlined"
              color="alternative"
              @click="cancelEdit"
            >
              Cancel
            </Button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs';
import FormLabel from '@/components/ui/FormLabel';
import GmSwitch from '@/components/ui/Switch';
import TextInput from '@/components/ui/TextInput';
import Button from '@/components/ui/Button';
import SelectRadio from '@/components/ui/SelectRadio';
import { EventBus } from '@/event-bus';

import constant from '@/store/constant';

export default {
  name: 'UserAdminEditNew',
  components: {
    HeaderBreadcrumbs,
    FormLabel,
    GmSwitch,
    TextInput,
    Button,
    SelectRadio
  },
  data() {
    return {
      form: {
        email: '',
        role: null,
        vendor:null,
        vendor_group:null,
        group: 'ebook',
        isActive: true
      },

      roleOptions: [],
      roleOption: [],  
      userData: JSON.parse(localStorage.getItem('session_auth')),
      isLoadingRole: false,
        emailAlreadyExists: false,
      isLoadingVendor:false,
      isLoadingVendorGroup:false,
      vendorOptions:[],
      vendorGroupOption:[],
      groupOptions: [
        { value: 'ebook', text: 'Ebook' },
        { value: 'publisher', text: 'Publisher' },
        { value: 'publisher_group', text: 'Publisher Group' }
      ],
      isLoadingUpdate: false,
      isSubmitted: false
    }
  },
  computed: {
    ...mapState({
      item: (state) => state.admin.item,
      successMessage: (state) => state.admin.successMessage,
      errorMessage: (state) => state.admin.errorMessage,
      isError: (state) => state.admin.isError
    }),
    isEmailError() {
      return !this.form.email.trim();
    },
    isRoleError() {
      return !this.form.role;
    },
    isGroupError() {
      return !this.form.group;
    },
    isVendorError() {
    if (this.form.group === 'ebook') {
      return false;
    }
    return !this.form.vendor;
  },
    isVendoGroupError() {
    if (this.form.group === 'ebook' || this.form.group === 'publisher') {
      return false;
    }
    return !this.form.vendor_group;
  }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Update User Admin | Content Management System Ebooks Gramedia.com';
      }
    },
     item: function async () {
      if (!Object.keys(this.item).length) return;
      //  this.populateForm();
    },
    successMessage: function() {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
        message: this.successMessage,
        type: 'success'
      });
      this.$router.push('/user-admin');
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
        message: this.errorMessage,
        type: 'error'
      });
    },
    isError: function() {
      if (!this.isError) return;
      EventBus.$emit('show-toast', {
        message: 'Ops. Something Went Wrong. Please Try Again',
        type: 'error'
      });
    }
  },
  async created() {
  const userID = this.$route.params.id;

  await Promise.all([
    this.fetchRole(),
    this.fetchUserAdminById({ id: userID })
  ]);

  this.populateForm();
},
//  validateForm() {
//       return (
//         !this.isEmailError &&
//         !this.isRoleError &&
//         !this.isGroupError
//       );
//     },


  mounted() {
   this.fetchRole();
  },
  methods: {
    ...mapActions('admin', ['updateUserAdmin', 'fetchUserAdminById']),
     ...mapActions('vendors', ['findVendor','fetchPublisherGroup','fetchVendorsById','fetchPublisherGroupById']),
    ...mapActions('accessRole', ['fetchAllRole']),

async fetchRole() {
  try {
    this.isLoadingRole = true;
    const res = await this.fetchAllRole();
    const hasRole14 = this.userData.role_id === 14

    const filteredRoles = hasRole14
      ? res.filter(item => item.id !== 1)
      : res;

    this.roleOptions = filteredRoles.map(item => ({
      value: item.id,
      text: item.name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase()),
      originalRole: item
    }));

  } finally {
    this.isLoadingRole = false;
  }
},
 validateForm() {
      this.emailAlreadyExists = false;

      const isEmailValid = this.form.email.trim() && !this.emailAlreadyExists;
      const isRoleValid = this.form.role !== null && this.form.role !== undefined;
      const isGroupValid = this.form.group !== null && this.form.group !== undefined;
      const isVendorValid = this.form.group === 'ebook' ||
       (this.form.vendor !== null && this.form.vendor !== undefined) || 
       (this.form.vendor_group !== null && this.form.vendor_group !== undefined) ;

      return isEmailValid && isRoleValid && isGroupValid && isVendorValid;
    },
  async populateForm() {
  const data = this.item;
  const group = data.group;

  this.form.group = group;
  const mapping = {
    publisher: constant.ALLOWED_ROLE_WITH_VENDOR,
    publisher_group: constant.ALLOWED_ROLE_WITH_VENDOR_GROUP
  };

  const vendorDataById = await this.fetchVendorsById({ id: data.vendor_id });
  this.form.vendor = vendorDataById?.data?.data;

  const vendorGroupDataById = await this.fetchPublisherGroupById({id: data.vendor_group_id})
  this.form.vendor_group = vendorGroupDataById
  this.roleOption = mapping[group]
    ? this.roleOptions.filter(r => mapping[group].includes(r.value))
    : this.roleOptions;

  this.form.email = data.email || '';
  this.form.role = data.roles ? data.roles.id : null;
  this.form.isActive = data.is_active || false;
 
},
 handleSearchVendorGroup(key) {
      if(key.length > 2) {
        this.isLoadingVendorGroup = true;
        const payload = {
            q:key,
             is_active:true
        }
         this.fetchPublisherGroup(payload)
          .then((resp) => {
            this.vendorGroupOption = resp.data.data.rows;
            this.isLoadingVendorGroup = false;
          })
          .catch((err) => {
            this.isLoadingVendorGroup = false;
            console.error(err);
          });
      }
    },
   changeGroup(selectedValue) {
   if (selectedValue === 'ebook') {
     this.roleOption = this.roleOptions
    }

    if (selectedValue === 'publisher') {
    this.roleOption = this.roleOptions.filter(r =>
      constant.ALLOWED_ROLE_WITH_VENDOR.includes(r.value)
    );
  }
    if (selectedValue === 'publisher_group') {
    this.roleOption = this.roleOptions.filter(r =>
      constant.ALLOWED_ROLE_WITH_VENDOR_GROUP.includes(r.value)
    );
  }
  },
  handleSearchVendor(keyword) {
      if (keyword.length > 2) {
        this.isLoadingVendor = true;
        const payload = {
          q: keyword
        };
        this.findVendor(payload)
          .then((resp) => {
            this.vendorOptions = resp.data.data;
            this.isLoadingVendor = false;
          })
          .catch((err) => {
            this.isLoadingVendor = false;
            console.error(err);
          });
      } else if (keyword.length === 0) {
        this.vendorOptions = [];
      }
    },
    async handleUpdateUserAdmin() {
      this.isSubmitted = true;

      if (!this.validateForm()) {
        return;
      }

      this.isLoadingUpdate = true;

      const userID = this.$route.params.id;
      const payload = {
        id: userID,
        email: this.form.email,
        role_id: this.form.role,
        group: this.form.group,
        is_active: this.form.isActive
      };
      if (payload.group === 'publisher' && this.form.vendor) {
              payload.vendor = this.form.vendor.id;
            } 
        if (payload.group === 'publisher_group' && this.form.vendor_group) {
          payload.vendor_group = this.form.vendor_group.id;
        }
      try {
        await this.$store.dispatch('admin/updateUserAdmin', payload);
      } catch (error) {
        console.error('Error updating user admin:', error);
      } finally {
        this.isLoadingUpdate = false;
      }
    },

    cancelEdit() {
      this.$router.push('/user-admin');
    }
  }
}
</script>
